module.exports = __webpack_public_path__ + "img/dialog-bg-suss.19c2e9a4.png";